/* ============
 * Account Module
 * ============
 */

import state from './state';
import mutations from './mutations';
import getters from './getters';

export default {
  state,
  mutations,
  getters,
};



// WEBPACK FOOTER //
// ./src/app/store/modules/adminPortal/index.js